<div class="counter" #counterElement>
  <div class="counter-content">
    @if (icon) {
      <i [class]="icon"></i>
    }
    <strong class="counter-value">{{ currentValue.toLocaleString() }}</strong>
    @if (label) {
      <label class="counter-label">{{ label }}</label>
    }
  </div>
</div>
